import axios from "axios"; // 导入 axios

// 创建 axios 实例
const service = axios.create({
    withCredentials: true, // 跨域请求时发送Cookie
    timeout: 10000 // 请求超时时间
});

service.interceptors.request.use(
    config => {
        config.headers["Content-type"] = "application/json;charset=UTF-8";
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error && error.response) {
            switch (error.response.status) {
                case 400:
                    error.message = "错误请求";
                    break;
                case 401:
                    error.message = "未授权，请重新登录";
                    break;
                case 403:
                    error.message = "拒绝访问";
                    break;
                case 404:
                    error.message = "请求错误,未找到该资源";
                    window.location.href = "/NotFound";
                    break;
                case 405:
                    error.message = "请求方法未允许";
                    break;
                case 408:
                    error.message = "请求超时";
                    break;
                case 500:
                    error.message = "服务器端出错";
                    break;
                case 501:
                    error.message = "网络未实现";
                    break;
                case 502:
                    error.message = "网络错误";
                    break;
                case 503:
                    error.message = "服务不可用";
                    break;
                case 504:
                    error.message = "网络超时";
                    break;
                case 505:
                    error.message = "http版本不支持该请求";
                    break;
                default:
                    error.message = `连接错误：${error}`;
            }
        } else {
            if (JSON.stringify(error).includes("timeout")) {
                this.$Toast.fail("服务器响应超时，请刷新当前页面。");
            }
            this.$Toast.fail("连接服务器失败");
        }
        this.$Toast.fail(error.response);
        return Promise.resolve(error.response);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/assets/js/request/request.js